import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import CompanyContMain from "presentation/view/container/Company/CompanyContMain";

CommonEntrypoint(<CompanyContMain/>)